import { render, staticRenderFns } from "./KegiatanPelayananNeonatal.vue?vue&type=template&id=f9a7d4d0"
import script from "./KegiatanPelayananNeonatal.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananNeonatal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a7d4d0')) {
      api.createRecord('f9a7d4d0', component.options)
    } else {
      api.reload('f9a7d4d0', component.options)
    }
    module.hot.accept("./KegiatanPelayananNeonatal.vue?vue&type=template&id=f9a7d4d0", function () {
      api.rerender('f9a7d4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananNeonatal.vue"
export default component.exports